(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yore-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yore-product-details')) {
    customElements.define('yore-product-details', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.groupDetails());
      }

      groupDetails() {
        if (this.dataset.enhanced === 'true') return;
        const source = this.querySelector('[data-detail-source]');
        if (!source) return;
        const groups = { condition: [], description: [], size: [], included: [], authentication: [] };
        const blocks = [];
        const cleanText = node => (node.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
        const collect = node => {
          if (node.nodeType === Node.TEXT_NODE) {
            if (cleanText(node)) {
              const paragraph = document.createElement('p');
              paragraph.textContent = node.textContent;
              blocks.push(paragraph);
            }
            return;
          }
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (['DIV', 'SECTION', 'ARTICLE', 'BLOCKQUOTE'].includes(node.tagName)) {
            Array.from(node.childNodes).forEach(collect);
          } else if (cleanText(node) || node.matches('img, video, audio, iframe, table') || node.querySelector('img, video, audio, iframe, table')) {
            blocks.push(node.cloneNode(true));
          }
        };
        Array.from(source.childNodes).forEach(collect);

        let current = 'description';
        for (const block of blocks) {
          const text = cleanText(block);
          const size = text.match(/^(?:size|dimensions?|measurements?)\s*(?:[:：-]\s*|$)(.*)$/i);
          const included = text.match(/^(?:what['’]s included|inclusions?|(?:hardware\s+)?accessories|included(?:\s+items|\s+accessories)?|packaging|comes(?:\s+complete)?\s+with|comes\s+as\s+(?:a\s+)?full\s+set(?:\s+including)?)\s*(?:[:：–—-]\s*|\s+|$)(.*)$/i);
          const authentication = text.match(/^(?:authentication|authenticity|certificate(?:\s+of\s+authenticity)?)\s*(?:[:：–—-]\s*|$)(.*)$/i);
          const condition = /^(?:(?:overall\s+)?condition(?: report)?|flaws(?:\s*\/\s*signs of wear)?|signs of wear)\s*(?:[:：-]|$)/i.test(text);
          const description = /^(?:description|product details|details)\s*(?:[:：-]|$)/i.test(text);
          if (included) {
            if (included[1]) groups.included.push(block);
            else current = 'included';
          } else if (authentication) {
            if (authentication[1]) groups.authentication.push(block);
            else current = 'authentication';
          } else if (size) {
            if (size[1]) groups.size.push(block);
            current = size[1] ? 'description' : 'size';
          } else if (condition) {
            current = 'condition';
            if (!/^(?:overall\s+)?condition(?: report)?\s*[:：-]?\s*$/i.test(text)) groups.condition.push(block);
          } else if (description) {
            current = 'description';
            if (!/^(?:description|product details|details)\s*[:：-]?\s*$/i.test(text)) groups.description.push(block);
          } else {
            groups[current].push(block);
          }
        }

        for (const [name, nodes] of Object.entries(groups)) {
          const section = this.querySelector(`[data-detail-section="${name}"]`);
          const content = this.querySelector(`[data-detail-content="${name}"]`);
          content.replaceChildren(...nodes);
          if (name === 'included') {
            this.querySelector('[data-included-fallback]').hidden = nodes.length > 0;
            continue;
          }
          if (name === 'authentication') continue;
          section.hidden = nodes.length === 0;
          section.open = name === 'condition' ? nodes.length > 0 : name === 'description' && groups.condition.length === 0;
        }
        this.dataset.enhanced = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yore-wishlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yore-wishlist')) {
    customElements.define('yore-wishlist', class extends HTMLElement {
      connectedCallback() {
        this.key = 'yore-house:wishlist:v1';
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.items = this.read();
        const options = { signal: this.controller.signal };
        document.addEventListener('click', (event) => this.onClick(event), options);
        window.addEventListener('storage', (event) => {
          if (event.key === this.key || event.key === null) {
            this.items = this.read();
            this.sync();
            if (this.dialog.open) this.renderItems();
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          document.querySelectorAll('[data-yore-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
          if (this.opener?.isConnected) this.opener.focus();
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.observer = new MutationObserver(records => {
          if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-yore-save], [data-yore-open]') || node.querySelector('[data-yore-save], [data-yore-open]'))))) this.sync();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
      normalize(item) {
        if (!item || !/^\d+$/.test(String(item.id)) || !/^[a-z0-9][a-z0-9-]*$/.test(item.handle || '') || typeof item.title !== 'string') return null;
        let image = '';
        try {
          const parsed = new URL(item.image || '', location.origin);
          if (item.image && parsed.protocol === 'https:' && (parsed.origin === location.origin || parsed.hostname === 'cdn.shopify.com' || parsed.hostname.endsWith('.myshopify.com'))) image = parsed.href;
        } catch {}
        return { id: String(item.id), handle: item.handle, title: item.title.slice(0, 500), image };
      }
      read() {
        try {
          const value = JSON.parse(localStorage.getItem(this.key) || '[]');
          if (!Array.isArray(value)) return [];
          const unique = new Map();
          value.forEach(item => { const safe = this.normalize(item); if (safe) unique.set(safe.id, safe); });
          return Array.from(unique.values());
        } catch { return []; }
      }
      persist() {
        try { localStorage.setItem(this.key, JSON.stringify(this.items)); this.storageFailed = false; }
        catch { this.storageFailed = true; }
      }
      sync() {
        document.querySelectorAll('[data-yore-save]').forEach(button => {
          const saved = this.items.some(item => item.id === button.dataset.productId);
          button.hidden = false;
          button.setAttribute('aria-pressed', String(saved));
          button.setAttribute('aria-label', `${saved ? this.dataset.removeLabel : this.dataset.saveLabel}: ${button.dataset.productTitle}`);
        });
        document.querySelectorAll('[data-yore-open]').forEach(button => button.hidden = false);
        document.querySelectorAll('[data-yore-count]').forEach(count => {
          count.textContent = String(this.items.length);
          count.hidden = this.items.length === 0;
        });
      }
      announce(message) {
        this.querySelector('[data-yore-status]').textContent = this.storageFailed ? this.dataset.unavailableMessage : message;
        const note = this.querySelector('.yore-wishlist-note');
        if (!this.normalNote) this.normalNote = note.textContent;
        note.textContent = this.storageFailed ? this.dataset.unavailableMessage : this.normalNote;
      }
      onClick(event) {
        if (!(event.target instanceof Element)) return;
        const save = event.target.closest('[data-yore-save]');
        const remove = event.target.closest('[data-yore-remove]');
        if (save || remove) {
          event.preventDefault();
          event.stopPropagation();
          if (!this.storageFailed) this.items = this.read();
          const id = save ? save.dataset.productId : remove.dataset.yoreRemove;
          const index = this.items.findIndex(item => item.id === id);
          let added = false;
          if (index !== -1) this.items.splice(index, 1);
          else if (save) {
            const item = this.normalize({ id, handle: save.dataset.productHandle, title: save.dataset.productTitle, image: save.dataset.productImage });
            if (!item) return;
            this.items.unshift(item);
            added = true;
          }
          this.persist();
          this.sync();
          this.announce(added ? this.dataset.addedMessage : this.dataset.removedMessage);
          if (this.dialog.open) {
            this.renderItems();
            this.querySelector('[data-yore-remove]')?.focus();
            if (!this.items.length) this.querySelector('[data-yore-close]').focus();
          }
          return;
        }
        const open = event.target.closest('[data-yore-open]');
        if (open) {
          event.preventDefault();
          this.opener = open;
          if (!this.storageFailed) this.items = this.read();
          this.sync();
          this.renderItems();
          this.dialog.showModal();
          open.setAttribute('aria-expanded', 'true');
        }
        if (event.target.closest('[data-yore-close]')) this.dialog.close();
      }
      renderItems() {
        const list = this.querySelector('[data-yore-items]');
        list.replaceChildren();
        this.querySelector('[data-yore-empty]').hidden = this.items.length > 0;
        const root = window.Shopify?.routes?.root || '/';
        this.items.forEach(item => {
          const row = document.createElement('li');
          row.className = 'yore-wishlist-item';
          const href = `${root}products/${encodeURIComponent(item.handle)}`;
          const photoLink = document.createElement('a');
          photoLink.href = href;
          photoLink.tabIndex = -1;
          photoLink.setAttribute('aria-hidden', 'true');
          if (item.image) {
            const photo = document.createElement('img');
            photo.src = item.image;
            photo.alt = '';
            photo.width = 88;
            photo.height = 100;
            photo.loading = 'lazy';
            photoLink.append(photo);
          }
          const detail = document.createElement('div');
          const heading = document.createElement('h3');
          const title = document.createElement('a');
          title.href = href;
          title.textContent = item.title;
          heading.append(title);
          const view = document.createElement('a');
          view.href = href;
          view.textContent = this.dataset.viewLabel;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.yoreRemove = item.id;
          remove.textContent = this.dataset.removeLabel;
          remove.setAttribute('aria-label', `${this.dataset.removeLabel}: ${item.title}`);
          detail.append(heading, view, remove);
          row.append(photoLink, detail);
          list.append(row);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
